import GuideAI from 'guideai-app';

import './styles.less';

export type GuideAIAppHandlerComponentProps = {
  organizationKey: string;
  apiKey: string;
};

const GuideAIAppHandlerComponent = ({ organizationKey, apiKey }: GuideAIAppHandlerComponentProps) => {
  return <div>
    <GuideAI
      organizationKey={organizationKey}
      apiKey={apiKey}
      key='k'
      position={{}}
      onError={(error) => console.error(error)}
    />
  </div>;
};

export default GuideAIAppHandlerComponent;
